import { getPendingUpdateId } from './getPendingUpdateId';
import type { ReactionModel } from './Reactions.types';
import { reactionsState } from './reactionsState';
import { updateReactionInSharedState } from './updateReactionInSharedState';

interface PendingUpdate {
  idAction: string;
  reaction: ReactionModel;
  type: 'add' | 'remove';
}

export const registerPendingReactionUpdate = (pendingUpdate: PendingUpdate) => {
  const { reaction, idAction, type } = pendingUpdate;
  const idUpdate = getPendingUpdateId(
    idAction,
    reaction.idEmoji,
    reaction.idMember,
  );

  if (reactionsState.value.pendingUpdates[idUpdate]) {
    // If this idUpdate already exists, that means they're undoing a pending
    // update.

    // Undo the optistic update
    if (type === 'add') {
      // Revert the tempReaction to the removed reaction
      updateReactionInSharedState(
        reactionsState.value.pendingUpdates[idUpdate].reaction,
      );
    }

    // Cancel the update
    const reactionsStateCopy = { ...reactionsState.value };
    delete reactionsStateCopy.pendingUpdates[idUpdate];
    reactionsState.setValue({
      ...reactionsStateCopy,
    });
  } else {
    // Otherwise, queue the pending update.
    reactionsState.setValue({
      ...reactionsState.value,
      pendingUpdates: {
        ...reactionsState.value.pendingUpdates,
        [idUpdate]: pendingUpdate,
      },
    });
  }
};
